module.exports = __webpack_public_path__ + "img/5.04f1b537.png";